import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import MainNavigationInfo from "components/mainNavInfo";
import { UWDecisions } from "types";

const UnderwritingNavInfoForMerchant = () => {
	const merchantInfo = useSelector(
		(state: any) => state.merchantInfo.merchantInfo,
	);
	const isMerchantInfoLoading = useSelector(
		(state: any) => state.merchantInfo.loading,
	);

	const decision = UWDecisions.getByName(merchantInfo?.underwritingDecision)
		?.displayName;

	const navInfoItems = useMemo(
		() => [
			{
				label: "Underwriting Decision",
				data: decision || "-",
			},
		],
		[decision],
	);

	return (
		<MainNavigationInfo
			content={navInfoItems}
			loading={isMerchantInfoLoading}
		/>
	);
};

export default UnderwritingNavInfoForMerchant;
